import React from "react";
import { Link, browserHistory } from "react-router";
import axios from "axios";
import { isLoggedIn } from "../components/Utils";

export default class Intro extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      onboarding_state: null
    };
  }

  handleSubmit = () => {
    axios
      .patch("/v1/users/self/", {
        onboarding_state: APP_CONFIG.onboarding_state
      })
      .then((response) => {
        browserHistory.push("/events");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  componentWillMount() {
    if (!isLoggedIn()) {
      browserHistory.push("/");
      return;
    }

    axios
      .get("/v1/users/self/")
      .then((response) => {
        this.setState({
          onboarding_state: response.data.onboarding_state
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  render() {
    return (
      <div className="content-container text-only">
        <div className="section-top">
          <h1>Welkom bij NIBHV Praktijktool</h1>
        </div>

        <div className="content text-links">
          <p>
            NIBHV hecht veel waarde aan de privacy. In ons <Link to="/privacy">privacy statement</Link> leggen we uit hoe we jouw privacy en die van anderen bewaken.
          </p>
          <p>
            Om gebruik te kunnen maken van NIBHV Praktijk moet je akkoord gaan met onze <Link to="/terms-of-use">gebruiksvoorwaarden</Link>.
          </p>
        </div>

        <button className="btn btn-primary" onClick={this.handleSubmit}>
          Ik ga akkoord
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/Intro.js